<template>
  <nav-bar title="部门监管工作落实情况统计" />
  <Content :bottom="0">
    <div class="title">检查完成情况</div>
    <div class="title_l"  ><span @click="handleFirstClick()" style="text-decoration: underline;color: blue">首次检查</span> <van-button type="primary" size="small" to="/supervise/1">督办</van-button></div>
    <div class="detail" @click="handleFirstClick()" style="text-decoration: underline;color: blue">
      <span>应检查：{{ state.firstList && state.firstList[0].planNum }}</span>
      <span>已检查：{{ state.firstList && state.firstList[0].finNum }}</span>
    </div>
    <div class="title_l"  ><span @click="handleComClick()" style="text-decoration: underline;color: blue">例行检查</span> <van-button type="primary" size="small" to="/supervise/2">督办</van-button></div>
    <div class="detail" @click="handleComClick()" style="text-decoration: underline;color: blue">
      <span>应检查：{{ state.comList && state.comList[0].planNum }}</span>
      <span>已延期：{{ state.comList && state.comList[0].finNum }}</span>
    </div>
    <div class="title_l"><span>专项检查</span> <van-button type="primary" size="small" to="/supervise/3">督办</van-button></div>
    <div class="list-item" v-for="item in state.spList" :key="item.cid">
      <p style="text-decoration: underline;color: blue" @click="handleSpClick(item)" >
        {{ item.ciitle }}
      </p>
      <div>
        <span>应检查：{{ item.planNum }}</span>
        <span>已检查：{{ item.finNum }}</span>
      </div>
    </div>
    <div class="title">通知阅读情况</div>
    <div class="list-item" v-for="item in list" :key="item.titleId">
      <p
        style="text-decoration: underline;color: blue"
        @click="handleClick(item)"
      >
        通知标题：{{ item.statTitle }}
      </p>
      <div>
        <span
          ><b>区域：{{ item.streetName }}</b></span
        >
        <span>应读：{{ item.planCount }}</span>
        <span>已读：{{ item.finishCount }}</span>
      </div>
    </div>
  </Content>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Dialog } from 'vant'
import {
  getOrgStat,
  getStatisticsCheckList,
  getRegionMess
} from '@/api/supervise'
import { computed, ref } from 'vue'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'SuperviseRisk',
  setup() {
    const store = useStore()
    const router = useRouter()
    const streetCode = computed(() => store.state.roleInfo.companyId)
    // 检查情况统
    const checkNum = ref({ planCount: 12, notCount: 5 })
    // useGetData(getCheckStatisticsMess, data => {
    //   checkNum.value = data
    // })(departId.value)
    // 通知阅读情况
    const list = ref([])
    var lev = ''
    useGetData(getOrgStat, data => {
      list.value = data
    })(streetCode.value)
    const handleClick = (item) => {
      // 处理下钻
      // useGetData(getNextOrgStat, data => {
      //   list.value = data
      // })(code)
      if (lev < 4) {
        router.push(`/noticeInfo/${item.titleId}/${item.statTitle} `)
      } else {
        Dialog.alert({
          message: '明细数据只提供到街道级别。'
        }).then(() => {
          // on close
        })
      }
    }
    const state = ref({})
    useGetData(getStatisticsCheckList, data => {
      state.value = data
    })(streetCode.value)
    useGetData(getRegionMess, data => {
      lev = data.level
    })(streetCode.value)

    const handleFirstClick = code => {
      // 首次检查
      if (lev < 4) {
        router.push('/checkInfo/01/01')
      } else {
        Dialog.alert({
          message: '明细数据只提供到街道级别。'
        }).then(() => {
          // on close
        })
      }
    }
    const handleComClick = code => {
      // 例行检查
      if (lev < 4) {
        router.push('/checkInfo/02/01')
      } else {
        Dialog.alert({
          message: '明细数据只提供到街道级别。'
        }).then(() => {
          // on close
        })
      }
    }
    const handleSpClick = (item) => {
      // 专项检查
      if (lev < 4) {
        router.push(`/checkInfo/03/${item.cid}`)
      } else {
        Dialog.alert({
          message: '明细数据只提供到街道级别。'
        }).then(() => {
        // on close
        })
      }
    }
    return {
      checkNum,
      list,
      handleFirstClick,
      handleComClick,
      handleClick,
      handleSpClick,
      state,
      lev
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.title_l {
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  background-color: #b6e6ff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.checkNum {
  font-size: 14px;
  padding: 0 16px;
  color: #333;
}
.list-item {
  padding: 16px;
  background-color: #fff;
  margin-bottom: 10px;
  p {
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }
  span {
    font-size: 14px;
    color: #666;
    margin-right: 16px;
  }
}
.detail {
  font-size: 14px;
  padding: 16px;
  background-color: #fff;
  span {
    margin-right: 10px;
  }
}
</style>
